import React from 'react';
import QRCode from 'react-qr-code';

const QrCode = ({paymentOptionList}) => {
  return (
    <QRCode
      size={256}
      style={{height: 'auto', maxWidth: '100px', width: '100px'}}
      value={paymentOptionList?.qrCodeImgUrl}
      viewBox={`0 0 256 256`}
    />
  );
};

export default QrCode;
